import { message } from "antd";
import ClientRequests from "app/api/client";
import { handleGenericApiError } from "app/api/error";
import { I18n } from "react-redux-i18n";
import { addLoading, removeLoading } from "./loading";

export const ACTION_SAVE_CLIENTS = "client:ACTION_SAVE_CLIENTS";
export const ACTION_SAVE_CLIENT_LOGINS = "client:ACTION_SAVE_CLIENT_LOGINS";
export const ACTION_SAVE_CLIENT = "client:ACTION_SAVE_CLIENT";
export const ACTION_SAVE_CLIENTS_CONSOLIDATED =
  "client:ACTION_SAVE_CLIENTS_CONSOLIDATED";
export const ACTION_CLEAR_SELECTED_CLIENT =
  "client:ACTION_CLEAR_SELECTED_CLIENT";

export const fetchClients = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await ClientRequests.fetchClients(params);
    dispatch({ type: ACTION_SAVE_CLIENTS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchClientLogins = params => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await ClientRequests.fetchClientLogins(params);
    dispatch({ type: ACTION_SAVE_CLIENT_LOGINS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchAllClients = params => async () => {
  try {
    return await ClientRequests.fetchClients(params);
  } catch (err) {
    handleGenericApiError(err);
  }
};

export const fetchClientById = id => async dispatch => {
  dispatch(addLoading());
  try {
    let data = await ClientRequests.fetchClientById(id);
    dispatch({ type: ACTION_SAVE_CLIENT, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadClients = params => async () => {
  if (
    params.searchParameter?.InitialClientDate &&
    params.searchParameter?.EndClientDate
  ) {
    var initialDate = params.searchParameter?.InitialClientDate.split(" ");
    var endDate = params.searchParameter?.EndClientDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await ClientRequests.downloadClients(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "clientes.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const downloadClientLoginsConsolidated = params => async () => {
  if (params.searchParameter?.InitialDate && params.searchParameter?.EndDate) {
    var initialDate = params.searchParameter?.InitialDate.split(" ");
    var endDate = params.searchParameter?.EndDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await ClientRequests.downloadClientLoginsConsolidated(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_logins.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const createClient = (data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ClientRequests.createClient(data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateClient = (id, data, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ClientRequests.updateClient(id, data);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const disableClient = (id, callback) => async dispatch => {
  dispatch(addLoading());
  try {
    await ClientRequests.disableClient(id);
    if (callback && typeof callback === "function") {
      callback();
    }
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const fetchClientsConsolidated = params => async dispatch => {
  dispatch(addLoading());
  try {
    const data = await ClientRequests.fetchClientsConsolidated(params);
    dispatch({ type: ACTION_SAVE_CLIENTS_CONSOLIDATED, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch(removeLoading());
  }
};

export const downloadClientsConsolidated = params => async () => {
  if (
    params.searchParameter?.InitialClientDate &&
    params.searchParameter?.EndClientDate
  ) {
    var initialDate = params.searchParameter?.InitialClientDate.split(" ");
    var endDate = params.searchParameter?.EndClientDate.split(" ");
    initialDate = new Date(initialDate[0]);
    endDate = new Date(endDate[0]);
    var totalDaysDiff = Math.abs(endDate - initialDate) / (1000 * 60 * 60 * 24);
    if (totalDaysDiff < 185) {
      try {
        const response = await ClientRequests.downloadClientsConsolidated(
          params.searchParameter
        );
        const link = document.createElement("a");
        link.href = response.data;
        link.setAttribute("download", "consolidados_clientes.csv");
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        handleGenericApiError(err);
      }
    } else {
      message.info(I18n.t("errors.DATE_FILTER_PERIOD_INVALID"));
      return false;
    }
  } else {
    message.info(I18n.t("errors.DATE_FILTER_ERROR"));
    return false;
  }
};

export const fetchClientIdByPrimaryDocument =
  primaryDocument => async dispatch => {
    dispatch(addLoading());

    try {
      const data =
        await ClientRequests.fetchClientIdByPrimaryDocument(primaryDocument);

      return data;
    } catch (err) {
      handleGenericApiError(err);

      return null;
    } finally {
      dispatch(removeLoading());
    }
  };
